var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 65,
    viewBox: "0 0 53 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3751 11.5729V2.38917C26.3751 0.907915 24.5976 0.183749 23.5772 1.23708L11.0689 13.7125C10.4105 14.3708 10.4105 15.3912 11.0689 16.0496L23.5443 28.525C24.5976 29.5454 26.3751 28.8212 26.3751 27.34V18.1562C38.653 18.1562 48.3635 29.4137 45.6643 42.1525C44.1172 49.6246 38.0605 55.6483 30.6214 57.1954C18.8701 59.6642 8.40263 51.5996 6.82263 40.7042C6.59222 39.1242 5.20972 37.9062 3.5968 37.9062C1.6218 37.9062 0.0417995 39.6508 0.305133 41.6258C2.34597 56.0762 16.1051 66.7742 31.6747 63.7458C41.9447 61.7379 50.2068 53.4758 52.2147 43.2058C55.4735 26.3196 42.636 11.5729 26.3751 11.5729Z",
    fill: "#147A88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayIcon);
export default __webpack_public_path__ + "static/media/replay-icon.a02e00718a2f214a2d311f0fa033b77b.svg";
export { ForwardRef as ReactComponent };